<template>
  <div class="header-sns-list" :class="!similar_data ? 'wide' : ''" ref="snsListOuter">
    <div class="header-sns-list-inner" ref="snsListInner">
    <div
      v-for="(instagram_data, index) in other_sns.instagram_data"
      :key="instagram_data.ig_id"
      class="i-detail-header-sns"
      :class="own_id != instagram_data.ig_id ? 'other' : ''"
      @click="toIDetail(instagram_data.account_name)"
      @mouseover="mouseover(index, 'instagram')"
      @mouseleave="mouseleave(instagram_data)"
      :id="'other-sns-' + instagram_data.id"
      v-show="instagram_data.displayable || admin_mode"
    >
      <div class="i-detail-header-sns-img">
        <el-image :src="instagram_data.profile_picture_url" class="i-detail-header-sns-el-img">
          <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
        </el-image>
        <div class="i-detail-header-sns-type instagram"><font-awesome-icon :icon="['fab', 'instagram']" /></div>
      </div>
      <div class="i-detail-header-sns-name">
        <div class="i-detail-header-sns-name-b">{{ instagram_data.account_name }}</div>
        <div>{{ Math.floor(instagram_data.followers_count / 1000) / 10 }}万人</div>
      </div>
    </div>
    <div
      v-for="(youtube_data, index) in other_sns.youtube_data"
      :key="youtube_data.channel_id"
      class="i-detail-header-sns"
      :class="own_id != youtube_data.channel_id ? 'other' : ''"
      @click="toYDetail(youtube_data.channel_id)"
      @mouseover="mouseover(index, 'youtube')"
      @mouseleave="mouseleave(youtube_data)"
      :id="'other-sns-' + youtube_data.id"
      v-show="youtube_data.displayable || admin_mode"
    >
      <div class="i-detail-header-sns-img">
        <el-image :src="youtube_data.profile_picture_url" class="i-detail-header-sns-el-img">
          <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
        </el-image>
        <div class="i-detail-header-sns-type youtube"><font-awesome-icon :icon="['fab', 'youtube']" /></div>
      </div>
      <div class="i-detail-header-sns-name">
        <div class="i-detail-header-sns-name-b">{{ youtube_data.account_name }}</div>
        <div v-if="youtube_data.hiddenSubscriberCount == 1" class="i-detail-header-sns-name-hidden">登録者非公開</div>
        <div v-else>{{ Math.floor(youtube_data.followers_count / 1000) / 10 }}万人</div>
      </div>
    </div>
    <div
      v-for="(tiktok_data, index) in other_sns.tiktok_data"
      :key="tiktok_data.tt_id"
      class="i-detail-header-sns"
      :class="own_id != tiktok_data.tt_id ? 'other' : ''"
      @click="toTTDetail(tiktok_data.account_name)"
      @mouseover="mouseover(index, 'tiktok')"
      @mouseleave="mouseleave(tiktok_data)"
      :id="'other-sns-' + tiktok_data.id"
      v-show="tiktok_data.displayable || admin_mode"
    >
      <div class="i-detail-header-sns-img">
        <el-image :src="tiktok_data.profile_picture_url" class="i-detail-header-sns-el-img">
          <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
        </el-image>
        <div class="i-detail-header-sns-type tiktok"><font-awesome-icon :icon="['fab', 'tiktok']" /></div>
      </div>
      <div class="i-detail-header-sns-name">
        <div class="i-detail-header-sns-name-b">{{ tiktok_data.account_name }}</div>
        <div>{{ Math.floor(tiktok_data.followers_count / 1000) / 10 }}万人</div>
      </div>
    </div>
    <div
      v-for="(twitter_data, index) in other_sns.twitter_data"
      :key="twitter_data.tw_id"
      class="i-detail-header-sns"
      :class="own_id != twitter_data.tw_id ? 'other' : ''"
      @click="toTWDetail(twitter_data.account_name)"
      @mouseover="mouseover(index, 'twitter')"
      @mouseleave="mouseleave(twitter_data)"
      :id="'other-sns-' + twitter_data.id"
      v-show="twitter_data.displayable || admin_mode"
    >
      <div class="i-detail-header-sns-img">
        <el-image :src="twitter_data.profile_picture_url" class="i-detail-header-sns-el-img">
          <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
        </el-image>
        <div class="i-detail-header-sns-type twitter">
          <svg width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
          </svg>
        </div>
      </div>
      <div class="i-detail-header-sns-name">
        <div class="i-detail-header-sns-name-b">{{ twitter_data.account_name }}</div>
        <div>{{ Math.floor(twitter_data.followers_count / 1000) / 10 }}万人</div>
      </div>
    </div>
    <!-- <div v-if="admin_mode && activate == 20" @click="copyCTT()" class="pointer" style="margin-left:20px"><font-awesome-icon :icon="['far', 'copy']" /></div>
    <div v-if="admin_mode && activate == 20" @click="copyCTTSolo()" class="pointer" style="margin-left:20px"><font-awesome-icon :icon="['far', 'copy']" />Solo</div> -->
    </div>

    <transition name="fade">
      <div
        class="i-detail-header-sns-hover"
        v-if="hover_show"
        :style="{ left: hover_position + 'px', top: hover_top + 'px' }"
        @mouseover="mouseoverHoverComponent()"
        @mouseleave="mouseleaveHoverComponent()"
      >
        <div class="i-detail-header-sns-top">
          <div class="i-detail-header-sns-img">
            <el-image :src="hover_item.profile_picture_url" class="i-detail-header-sns-el-img">
              <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
            </el-image>
            <div v-if="hover_item.sns_type == 'twitter'" class="i-detail-header-sns-type twitter">
              <svg width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
              </svg>
            </div>
            <div v-else class="i-detail-header-sns-type" :class="hover_item.sns_type"><font-awesome-icon :icon="['fab', hover_item.sns_type]" /></div>
          </div>
          <div class="i-detail-header-sns-name">
            <div class="i-detail-header-sns-name-keep">
              {{ hover_item.account_name }}
              <font-awesome-icon :icon="['fas', 'check-circle']" v-show="hover_item.badge == 1 && hover_item.sns_type == 'tiktok'" class="tt-badge small" />
              <font-awesome-icon :icon="['fas', 'badge-check']" v-show="hover_item.badge == 1 && hover_item.sns_type == 'twitter'" class="tw-badge small" />
              <img src="../../assets/badge.png" style="width:11px; height:11px; margin-left:3px" v-show="hover_item.badge == 1 && hover_item.sns_type == 'instagram'" />
            </div>
            <div class="i-detail-header-sns-name-keep name">{{ hover_item.name }}</div>
            <div class="i-detail-header-sns-num-wrap" v-if="hover_item.hiddenSubscriberCount == 1">登録者数非公開</div>
            <div class="i-detail-header-sns-num-wrap" v-else>
              <span class="i-detail-header-sns-num">{{ hover_item.followers_count | addComma }}</span
              >人
            </div>
            <div style="margin-top:10px" v-if="activate == 20 && admin_mode">{{ hover_item.id }}</div>
            <div class="data-table-th-usergender" style="margin-top: 10px" v-if="activate == 20 && admin_mode">
              <div class="pointer" @click="changeGender('nodisplay', hover_item.id)" :class="hover_item.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
              <div class="pointer" @click="changeGender('', hover_item.id)" :class="hover_item.gender == '' ? 'active null' : ''">未設定</div>
              <div class="pointer" @click="changeGender('女性', hover_item.id)" :class="hover_item.gender == '女性' ? 'active' : ''">女性</div>
              <div class="pointer" @click="changeGender('男性', hover_item.id)" :class="hover_item.gender == '男性' ? 'active' : ''">男性</div>
              <div
                class="pointer"
                @click="changeGender('グループ', hover_item.id)"
                :class="hover_item.gender == 'グループ' ? 'active' : ''"
                v-if="hover_item.sns_type == 'youtube' || hover_item.sns_type == 'tiktok'"
              >
                グループ
              </div>
              <div class="pointer" @click="changeGender('その他', hover_item.id)" :class="hover_item.gender == 'その他' ? 'active' : ''">その他</div>
            </div>
          </div>
        </div>
        <div class="i-detail-header-sns-bottom" v-show="hover_item.biography">
          <div class="i-detail-header-sns-divider"></div>
          <div class="i-detail-header-sns-bio">{{ hover_item.biography }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeGenderAPI = root + "/api/admin/change_gender";

export default {
  name: "otherSNS",
  props: ["own_id", "parent_component", "other_sns", "similar_data", "child"],
  data() {
    return {
      hover_item: [],
      hover_index: 0,
      hover_show: false,
      hover_position: 20,
      hover_top: 0,
      hover_component: false,
      before_id: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {
    this.updateScrollOverflow();
    window.addEventListener("resize", this.updateScrollOverflow);
  },
  updated() {
    this.$nextTick(this.updateScrollOverflow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScrollOverflow);
  },
  methods: {
    updateScrollOverflow() {
      const outer = this.$refs.snsListOuter;
      const inner = this.$refs.snsListInner;
      if (!outer || !inner) return;
      outer.style.overflowX = inner.scrollWidth > outer.clientWidth + 1 ? "auto" : "hidden";
    },
    mouseover(hover_index, sns_type) {
      this.hover_item = this.other_sns[sns_type + "_data"][hover_index];
      this.hover_item.sns_type = sns_type;
      this.hover_index = hover_index;
      this.hover_component = false;
      const id = "other-sns-" + this.hover_item.id;
      const el = document.getElementById(id);
      if (!el) {
        this.hover_show = false;
        this.hover_item = [];
        return;
      }
      const rect = el.getBoundingClientRect();
      const vw = document.documentElement.clientWidth || window.innerWidth;
      // position: fixed なので viewport 座標（pageXOffset は二重計算になる）
      this.hover_top = Math.round(rect.bottom + 4);
      this.hover_position = Math.round(rect.left - 5);
      if (this.hover_position + 230 > vw) {
        this.hover_position = Math.max(5, vw - 230 - 5);
      }
      this.hover_show = true;
    },
    mouseleave(hover_item) {
      this.before_id = hover_item.id;
      setTimeout(() => {
        if (!this.hover_component && this.before_id == this.hover_item.id) {
          this.hover_item = [];
          this.hover_show = false;
        }
      }, 100);
    },
    mouseoverHoverComponent() {
      this.hover_component = true;
    },
    mouseleaveHoverComponent() {
      this.hover_item = [];
      this.hover_show = false;
      this.hover_component = false;
    },
    toIDetail(account_name) {
      
      // 既に詳細ページにいる場合は遷移しない
      if(this.$route.name === "influencerDetail" || this.$route.name === this.parent_component + "_influencerDetailDrawer") return;
      
      this.$router.push({
        name: this.child == true ? this.parent_component + "_influencerDetailDrawer" : "influencerDetail",
        params: {
          account_name: account_name,
          child: this.child,
          parent_component: this.parent_component,
        },
      });
    },
    toYDetail(channel_id) {
      
      // 既に詳細ページにいる場合は遷移しない
      if(this.$route.name === "youtuberDetail" || this.$route.name === this.parent_component + "_youtuberDetailDrawer") return;
      
      this.$router.push({
        name: this.child == true ? this.parent_component + "_youtuberDetailDrawer" : "youtuberDetail",
        params: {
          channel_id: channel_id,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toTTDetail(account_name) {
      
      // 既に詳細ページにいる場合は遷移しない
      if(this.$route.name === "tiktokerDetail" || this.$route.name === this.parent_component + "_tiktokerDetailDrawer") return;
      
      this.$router.push({
        name: this.child == true ? this.parent_component + "_tiktokerDetailDrawer" : "tiktokerDetail",
        params: {
          account_name: account_name,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    toTWDetail(account_name) {
      
      // 既に詳細ページにいる場合は遷移しない
      if(this.$route.name === "twittererDetail" || this.$route.name === this.parent_component + "_twittererDetailDrawer") return;
      
      this.$router.push({
        name: this.child == true ? this.parent_component + "_twittererDetailDrawer" : "twittererDetail",
        params: {
          account_name: account_name,
          child: this.child == true ? true : false,
          parent_component: this.parent_component,
        },
      });
    },
    changeGender(command, id) {
      this.axios.get(changeGenderAPI, {
        params: {
          id: id,
          sns_type: this.hover_item.sns_type,
          gender: encodeURI(command == "" ? "null" : command),
          token: this.token,
        },
      });
      this.other_sns[this.hover_item.sns_type + "_data"][this.hover_index]["gender"] = command;
    },
    copyCTT() {
      if (this.other_sns["instagram_data"][0]) var instagram = " -i" + this.other_sns["instagram_data"][0]["account_name"];
      else instagram = "";
      if (this.other_sns["youtube_data"][0]) var youtube = " -y" + this.other_sns["youtube_data"][0]["channel_id"];
      else youtube = "";
      if (this.other_sns["tiktok_data"][0]) var tiktok = " -t" + this.other_sns["tiktok_data"][0]["account_name"];
      else tiktok = "";
      if (this.other_sns["twitter_data"][0]) var twitter = " -t" + this.other_sns["twitter_data"][0]["account_name"];
      else twitter = "";
      var text = "php ctt.php" + instagram + youtube + tiktok + twitter + " ";
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "コードがコピーされました",
        });
      });
    },
    copyCTTSolo() {
      var tiktok = " -t" + this.other_sns["tiktok_data"][0]["account_name"] + " --solo";
      var text = "php ctt.php" + tiktok;
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "Soloコードがコピーされました",
        });
      });
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
};
</script>

<style></style>
